import { IN_PROGRESS_REPORT_STATUSES } from '../api/types'

import type { ReportStatus } from 'features/yieldbirdWrapperAgent/api/types'

const inProgressStatuses: readonly ReportStatus[] = IN_PROGRESS_REPORT_STATUSES

export const isReportInProgress = (status: ReportStatus): boolean =>
  inProgressStatuses.includes(status)
